import { Action, createReducer, on } from '@ngrx/store';
import { PayRateActionState } from './state/user.state';
import {
    ActionType,
    setResetUserAction,
    setSearchRateUserAction,
    setSaveRateUserAction,
    setAddRateUserAction,
    setDeleteRateUserAction,
    setEditRateUserAction,
    setCopyRatesUserAction
} from './actions/user.actions';

export const userFeatureKey = 'user-actions';

export const initialState: PayRateActionState = {
    actionInfo: { actionType: ActionType.None, data: undefined },
    error: undefined
};

const userReducer = createReducer(
    initialState,

    on(setResetUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.None, data: action.data }
    })),
    on(setSearchRateUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.Rate_Search, data: action.data }
    })),
    on(setSaveRateUserAction, (state, action) => ({
        ...state,
        actionInfo: {
            ...state.actionInfo,
            actionType: ActionType.Rate_Save,
            data: action.data
        }
    })),
    on(setAddRateUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.Rate_Add, data: action.data }
    })),
    on(setDeleteRateUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.Rate_Delete, data: action.data }
    })),
    on(setEditRateUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.Rate_Edit, data: action.data }
    })),
    on(setCopyRatesUserAction, (state, action) => ({
        ...state,
        actionInfo: { actionType: ActionType.Rate_Copy, data: action.data }
    }))
);

export function reducer(state: PayRateActionState | undefined, action: Action) {
    return userReducer(state, action);
}
